import { v4 as uuidv4 } from 'uuid';

function getRandomLowercaseLetter(): string {
    const letters = 'abcdefghijklmnopqrstuvwxyz';
    const randomIndex = Math.floor(Math.random() * letters.length);
    return letters[randomIndex];
}

function getId(): string {
    // to make sure if used as id it start with letter
    const startLetter = getRandomLowercaseLetter();
    return startLetter + uuidv4().slice(1);
}

export const generateId = (n = 1): string | string[] => {
    // if just need 1 id just return id as string
    if (n <= 1) {
        return getId();
    }

    // return with array of string
    const idArray = [];
    for (let i = 0; i < n; i += 1) {
        idArray.push(getId());
    }

    return idArray as string[];
};

export default { generateId };
